export default __webpack_public_path__ + "playground-logo.685eff74.png";